module.exports = __webpack_public_path__ + "static/media/bold.b5292657.woff";